import { FC, useState } from "react";
import { Controller} from "react-hook-form";
import {   Input } from "rsuite";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons/lib/icons";

import "./CustomInput.scss";
import { Body } from "../Typography/Typography";

const CustomInput: FC<CustomInputProps> = ({
  leftIcon,
  placeholder,
  defaultValue,
  control,
  name,
  label,
  value,
  type,
  isDisabled,
  handleOnChange,
  inputStyles,
  errorMessage,
  inputContainerStyle,
  leftIconStyle,
  inputProps,
  maxLength,
  labelStyle,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const baseClasses =
    "w-full px-3 !py-3  border bg-input text-sm rounded font-normal relative leading-tight focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition-all duration-200";

  const stateClasses = errorMessage ? "border-red-300 focus:ring-red-500" : "border-gray-200 focus:ring-green-500";

  const disabledClasses = isDisabled ? "bg-input-disabled cursor-not-allowed" : "";
  const leftIconClasses = leftIcon ? "pl-36" : "";

  const classes = `
      ${baseClasses}
      ${stateClasses}
      ${disabledClasses}
      ${leftIconClasses}
      ${inputStyles}
    `
    .trim()
    .replace(/\s+/g, " ");

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className={`relative w-full mb-6 ${inputContainerStyle}`}>
       
      {label && (
        <Body color="tertiary" as="label" htmlFor={name} className={`block mb-2 ${labelStyle}`}>
          {label}
        </Body>
      )}

      {leftIcon && <div className={`absolute top-[13px] left-[15px] ${leftIconStyle}`}>{leftIcon}</div>}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, onBlur, value } }: { field: any }) => (
          <Input
            id={name}
            type={type === "password" && showPassword ? "text" : type}
            value={value}
            onBlur={onBlur}
            onChange={(value, event) => {
              onChange(value);
              handleOnChange?.(event);
            }}
            placeholder={placeholder}
            maxLength={maxLength}
            {...inputProps}
             
            className={classes}
            disabled={isDisabled}

          />
        )}
      />
      {type === "password" && (
        <div onClick={handleShowPassword} className="absolute top-[35px] right-[15px]">
          {type === "password" && showPassword ? (
            <div className={type === "password" && showPassword ? "show-password" : "hide-password"}>
              <EyeOutlined />
            </div>
          ) : (
            <div className={type === "password" && showPassword ? "hide-password" : "show-password"}>
              <EyeInvisibleOutlined />
            </div>
          )}
        </div>
      )}
      {errorMessage && <p className="text-[#FF3B30] text-[12px]">{errorMessage}</p>}
    </div>
  );
};

export default CustomInput;
